import React, { useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import lowerBanner from '../../assets/images/happy.png';
import product1 from '../../assets/images/1.jpg';
import product2 from '../../assets/images/kid.png';
import product3 from '../../assets/images/img.jpeg';
import product4 from '../../assets/images/shalwar.png';
import product5 from '../../assets/images/kid1.jpg';
import product6 from '../../assets/images/image.png';
import card1 from '../../assets/images/W25P1002_01.png';
import card2 from '../../assets/images/W25P2004_05.png';
import card3 from '../../assets/images/W25P2005_04.png';
import card4 from '../../assets/images/W25P2009_05.png';
import bigImage from '../../assets/images/bigImage.jpg';

function PreviewSecond({ primaryColor  , secColor}) {
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const products = [
        {
            id: 1,
            image: card1,
            title: 'Product 1',
            description: 'High-quality product with best price',
            price: 'Rs. 2,689',
            rating: '⭐⭐⭐⭐⭐ (1.4K sold)'
        },
        {
            id: 2,
            image: card2,
            title: 'Product 2',
            description: 'Durable and stylish, perfect for your needs',
            price: 'Rs. 2,140',
            rating: '⭐⭐⭐⭐ (14 sold)'
        },
        {
            id: 3,
            image: card3,
            title: 'Product 3',
            description: 'Premium quality, best for home & office',
            price: 'Rs. 3,200',
            rating: '⭐⭐⭐⭐⭐ (3.5K sold)'
        },
        {
            id: 4,
            image: card4,
            title: 'Product 4',
            description: 'Affordable & reliable choice for everyone',
            price: 'Rs. 1,999',
            rating: '⭐⭐⭐⭐ (2.2K sold)'
        }
    ];

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    };

    const images = [product1, product2, product3, product4, product5, product6];

    const image = [card1, card2, card3, card4];
    return (
        <div className="template1__container">
            {/* Upper Banner */}
            <div className="template1__banner">
                <img src={lowerBanner} alt="Upper Banner" className="template1__upperbanner" />
            </div>

            <div className="latest-arrivals">
                <h2 style={{ color: `${primaryColor}` }}>LATEST ARRIVALS</h2>
                <div className="category-tabs">
                    <span style={{ color: `${secColor}` }}>READY TO WEAR</span>
                    <span style={{ color: `${secColor}` }}>UNSTITCHED</span>
                    <span style={{ color: `${secColor}` }}>FRAGRANCES</span>
                    <span style={{ color: `${secColor}` }}>BEAUTY</span>
                    <span style={{ color: `${secColor}` }}>MENSWEAR</span>
                </div>
            </div>

            <div className="fragrance-section">
                {/* Left Side Image */}
                <div className="fragrance-banner">
                    <img src={bigImage} alt="Fragrance" className="big-image" />
                </div>

                {/* Right Side Slider */}
                <div className="fragrance-slider">
                    <Slider {...settings}>
                        {images.map((img, index) => (
                            <div key={index} className="slider-item">
                                <img src={img} alt={`Product ${index + 1}`} className="product-image" />
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>

            <h4 className="mt-7" style={{ color: `${primaryColor}` }}>
                Store collection
            </h4>
            <div className="gallery mt-8">
                {images?.map((img, index) => (
                    <div key={index} style={{ backgroundImage: `url(${img})` }} className="gallery-img">
                        <button style={{ backgroundColor: `${primaryColor}`, color: `${secColor}` }}>View Details</button>
                    </div>
                ))}
            </div>

            {/* Slider Section */}
            <div className="template1__container">
                <Slider {...settings}>
                    {products.map((product, index) => (
                        <div key={product.id} className="template1__card" onMouseEnter={() => setHoveredIndex(index)} onMouseLeave={() => setHoveredIndex(null)}>
                            <img src={product.image} alt={product.title} className="template1__product" />
                            {hoveredIndex === index && (
                                <div className="product__overlay">
                                    <h4 className="mt-8" style={{ color: `${primaryColor}` }}>
                                        {product.title}
                                    </h4>
                                    <p style={{ color: `${secColor}` }}>{product.description}</p>
                                    <p>{product.price}</p>
                                    <p>{product.rating}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
}

export default PreviewSecond;
